import Client from "./_client";

export const getShortlistingTask = async (filters) => {
  let url = `/shortlistTask/stats?`;

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  }); 

  const result = await new Client({
    path: url
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get shortliting tasks. Please try again."
    );
  }

  if (result.name === "DuplicateSession") {
    return result;
  } else {
    return result.data;
  }
};

export const analyseResume = async (payload) => {
  let url = `/analyse/resume`;

  const result = await new Client({
    path: url,
    payload
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to analyse resume. Please try again."
    );
  }

  if (result.name === "DuplicateSession") {
    return result;
  } else {
    return result.data;
  }
};

export const submitResumeScore = async (id) => {
  let url = `/resumeInsight/${id}/submit`;

  const result = await new Client({
    path: url
  }).put();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to submit score. Please try again."
    );
  }

  if (result.name === "DuplicateSession") {
    return result;
  } else {
    return result.data;
  }
};

export const getResumeAnalysisHistory = async (filters = {}) => {
  const params = new URLSearchParams({ include: "resume,shortlistTask" });

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined) params.append(key, value);
  });

  const url = `/resumeInsight?${params.toString()}`;

  const result = await new Client({ path: url }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to fetch history. Please try again."
    );
  }

  if (result.name === "DuplicateSession") {
    return result;
  } else {
    return result.data;
  }
};


export const getShortlistFeedback = async (id) => {
  let url = `/resumeInsight/${id}`;

  const result = await new Client({
    path: url
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get shortliting feedback. Please try again."
    );
  }

  if (result.name === "DuplicateSession") {
    return result;
  } else {
    return result.data;
  }
};